<template>
  <div class="step-when pb-20 grid grid-cols-2 mdsm:grid-cols-1 gap-20 md:gap-10 sm:gap-6">
    <div>
      <wizard-header
        :on-back="onBack"
        :curr-step="currStep"
        title="When would you like to go?"
        sub-title="Select your month of travel or skip this step"
      />
      <div class="grid grid-cols-3 sm:grid-cols-2 gap-4">
        <wizard-item
          v-for="item in items"
          :key="item"
          :title="item.charAt(0).toUpperCase() + item.slice(1)"
          :on-click="() => onChange(item)"
          :active="selected === item"
        />
      </div>

      <wizard-action
        :on-continue="onContinue"
        :disabledContinue="!selected"
        :on-skip="onSkip"
      />
    </div>
    <div class="h-full md:hidden sm:hidden">
      <img
        src="/img/wizard/step-when.png"
        alt="wizard-banner"
        class="object-contain h-full w-full"
      />
    </div>
  </div>
</template>

<script>
import WizardHeader from "../../components/Wizard/Header";
import WizardItem from "../../components/Wizard/Item";
import WizardAction from "../../components/Wizard/Action";

export default {
  name: "StepWhen",
  components: {
    WizardHeader,
    WizardItem,
    WizardAction,
  },
  mounted() {
    this.init();
  },
  props: {
    currSelection: {
      type: Object,
      default: () => ({}),
    },
    currStep: { type: Number, default: 2 },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: "",
    };
  },
  methods: {
    init() {
      const currSelection = this.currSelection;
      const stepWhenData = currSelection["when"];
      this.selected = Boolean(stepWhenData) ? stepWhenData : "";
    },
    onBack() {
      this.$emit("on-back", this.selected);
    },
    onContinue() {
      this.$emit("on-continue", this.selected);
    },
    onSkip() {
      this.onChange(false);
      this.$emit("on-skip", this.selected);
    },
    onChange(month) {
      if (!month) {
        this.selected = "";
        return this.$emit("on-change", this.selected);
      }
      this.selected = this.selected !== month ? month : "";
      this.$emit("on-change", this.selected);
    },
  },
};
</script>
